export default __webpack_public_path__ + "static/media/user-icon.e235d689.png";